import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ChallengeHistoryRanking, ChallengeParticipant, ChallengeStatus, ListParticipants, RankingItem } from '../challenge.model';
import { GridOptions } from 'ag-grid-community';
import { ChallengesService } from '../challenges.service';

@Component({
    selector: "cv-cxone-challenge-participants-modal",
    templateUrl: "./cxone-challenge-participants-modal.component.html",
    styleUrl: "./cxone-challenge-participants-modal.component.scss",
})
export class CxoneChallengeParticipantsModalComponent implements OnInit {
    participantsRanking: RankingItem[] | ChallengeHistoryRanking[] =
        this.dialogConfig.data.participantsRanking;
    participants: ChallengeParticipant[] = this.dialogConfig.data.participants;
    pendingParticipants: RankingItem[] =
        this.dialogConfig.data.pendingParticipants;
    allowClose: boolean = true;
    headerTitle: string = this.dialogConfig.data.headerTitle;
    saveLabel: string = this.dialogConfig.data.saveLabel;
    challengeStatus: ChallengeStatus = this.dialogConfig.data.challengeStatus;
    getLocalizationString: (key: string, defaultValue: string) => string =
        this.dialogConfig.data.getLocalizationString;
    gridOptions: GridOptions = null;
    localizationStrings: Map<string, string> = new Map<string, string>();
    listParticipants: ListParticipants[] = [];
    currentUser: any = null;
    creatorName: string = this.dialogConfig.data.creatorName;

    constructor(
        private dialogConfig: DynamicDialogConfig,
        private dialogRef: DynamicDialogRef,
        private challengeService: ChallengesService
    ) {}

    async ngOnInit() {
        await this.loadInformation();
    }

    async loadCurrentUser(): Promise<void> {
        this.currentUser = await this.challengeService.getCurrentUser();
    }

    formatLists() {
        let currentParticipants = [];
        const isMyChallenge = this.currentUser === this.creatorName;
        const myParticipant = {
            Name: this.creatorName,
            Status: this.getLocalizationString("Challenger", "Challenger"),
        };
        if (this.challengeStatus !== "ended") {
            currentParticipants = this.participants
                .filter((participant) =>
                    isMyChallenge
                        ? participant.LoginName !==
                              this.getLocalizationString("Me", "Me") &&
                          participant.LoginName !== this.currentUser
                        : participant.LoginName !== this.creatorName
                )
                .map((participant) => ({
                    Name:
                        participant.LoginName ===
                        this.getLocalizationString("Me", "Me")
                            ? this.currentUser
                            : participant.LoginName,
                    Status: this.getLocalizationString("Accepted", "Accepted"),
                }));
        } else {
            currentParticipants = this.participantsRanking
                .filter((ranking) =>
                    isMyChallenge
                        ? ranking.Name !==
                              this.getLocalizationString("Me", "Me") &&
                          ranking.Name !== this.currentUser
                        : ranking.Name !== this.creatorName
                )
                .map((ranking) => ({
                    Name:
                        ranking.Name === this.getLocalizationString("Me", "Me")
                            ? this.currentUser
                            : ranking.Name,
                    Status: ranking.Place
                        ? this.getLocalizationString("Accepted", "Accepted")
                        : this.getLocalizationString("Declined", "Declined"),
                }));
        }

        const pendingParticipants = this.pendingParticipants.map((ranking) => ({
            Name: ranking.Name === this.getLocalizationString("Me", "Me") ? this.currentUser : ranking.Name,
            Status: this.getLocalizationString("Pending", "Pending"),
        }));

        // Combine all participants
        this.listParticipants = [
            myParticipant,
            ...currentParticipants,
            ...pendingParticipants,
        ];
    }

    onDismiss() {
        this.dialogRef.close();
    }

    onClose() {
        this.dialogRef.close();
    }

    async loadInformation() {
        await this.loadCurrentUser();
        this.formatLists();
        this.setupGrid();
    }

    setupGrid() {
        this.gridOptions = {
            suppressDragLeaveHidesColumns: true,
            suppressRowGroupHidesColumns: true,
            suppressContextMenu: true,
            suppressCellFocus: true,
            rowHeight: 36,
            headerHeight: 44,
            suppressPreventDefaultOnMouseWheel: true,
            suppressHorizontalScroll: true,
            enableBrowserTooltips: false,
            overlayNoRowsTemplate: `<div class="error-container">
                                        <svg class="cxoneFavoriteState mb-2" style="width: 165.94px !important;height:92px !important;">
                                            <use href="../App_Themes/CXone/icons/empty-state.svg#empty-state"></use>
                                        </svg>
                                        <p class="cxone-error-text" style="color:#758994;">${this.getLocalizationString(
                                            "No_Participants_Found",
                                            "No participants found"
                                        )}</p>
                                    </div>`,
            columnDefs: [
                {
                    headerName: this.getLocalizationString(
                        "Participant",
                        "Participant"
                    ),
                    field: "Name",
                },
                {
                    headerName: this.getLocalizationString("Status", "Status"),
                    field: "Status",
                },
            ],
            defaultColDef: {
                resizable: false,
                suppressMenu: true,
            },
            rowData: this.listParticipants,
            onGridReady: (params) => {
                params.api.sizeColumnsToFit();
            },
        };
    }
}
